import React, {useContext} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import AddAffinityPage from "../../components/Formularios/addAffinity/AddAffinityPage";
import useWindowDimensions from "../../useWindowDimensions";
import SideNavBarMUI from "../../components/manager/SideNavBarMUI";
import MasterContext from "../../context/MasterContext";
import {
    Card,
    CardContent,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    cardStyle: {
        boxShadow: "2px 2px 2px 2px rgba(0, 0, 0, 0.2)",
    },
    parentColumn: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
    },
    bodyRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        marginTop: "72px",
    },
    divHeader: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        position: "absolute"
    },
    divFormBox: {
        display: "flex",
        flexDirection: "row",
    },
    formBox: {
        backgroundColor: "#fff",
        borderRadius: "20px",
        width: "800px",
        boxShadow: "5px 10px 18px #888888",
        padding: "20px",
    },

}))

function NewAffinity(props) {
    const classes = useStyles();
    const {width, height} = useWindowDimensions();
    const {open} = useContext(MasterContext);

    return (
        <React.Fragment>
            <div className={classes.parentColumn}>
                <div className={classes.divHeader}>
                    <SideNavBarMUI role={"Administrador"}/>
                </div>
                <div
                    className={classes.bodyRow}
                    style={{
                        left: open ? "240px" : "60px",
                        transitionProperty: "left",
                        transitionDuration: "1s",
                        width: open ? `${width - 260}px` : `${width - 80}px`,
                        height: `${height - 80}px`
                    }}>

                    <Card
                        className={classes.cardStyle}
                        style={{width: "800px", height: "auto", backgroundColor: "#fff", margin: "8px 8px"}}
                    >
                        <CardContent style={{height: "100%", padding: "8px"}}>

                            {typeof props.location.state !== 'undefined'
                                ? <AddAffinityPage editInfo={props.location.state.data}/>
                                : <AddAffinityPage/>
                            }

                        </CardContent></Card>
                </div>

            </div>

        </React.Fragment>
    );
}

export default NewAffinity;